import { GetServerSideProps } from 'next';

import { getContactPageData } from 'lib/sanity';
import { serverExceptionHandler } from 'utils/exceptionHandler';
import { getLoginRedirect } from 'utils/login/login';
import ContactPage from 'components/ContactPage';
import { getSharedPageData, SharedPageData } from 'utils/shared-page-data';
import { Vertical } from 'utils/vertical';

const loginProtectedUrls = ['/contact-spotify-support/'];

export const getServerSideProps: GetServerSideProps = async context => {
  const { query, resolvedUrl } = context;
  const market = query.market as string;
  let vertical: Vertical | undefined;
  let sharedPageData: SharedPageData | undefined;

  try {
    sharedPageData = await getSharedPageData(context);
    vertical = sharedPageData.vertical;

    // TODO: once we reliably can use Next Middlewares, this to me sounds like a great usecase.
    if (!sharedPageData.isLoggedIn && loginProtectedUrls.find(url => resolvedUrl.includes(url))) {
      return getLoginRedirect({
        market,
        vertical,
        url: resolvedUrl,
      });
    }

    const { masthead: mastheadData, banner } = await getContactPageData(market, vertical);
    return { props: { banner, mastheadData, sharedPageData } };
  } catch (error) {
    try {
      return serverExceptionHandler(error, 'contact-page', { market, vertical });
    } catch {
      // Contactpage works fine without banners or masthead data
      return { props: { banner: null, sharedPageData } };
    }
  }
};

export default ContactPage;
